import Vue from 'vue'
import request from './request'
import { removeTypename } from 'utils/removeTypename'

const way = './graphql/group of accreditations/',
  mutation_way =  way + 'mutations/',
  query_way =  way + 'query/',
  environment = '/accreditation'

export default class GroupOfAccreditationsApi {
  async getAccreditationGroups(pagination = {}) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getAccreditationGroups',
      variables: { pagination },
      way: query_way,
      has_catch: true
    })
  }
  async getAccreditationGroupById(id) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getAccreditationGroupById',
      variables: { id },
      way: query_way,
      has_catch: true
    })
  }
  async getAccreditationRequestsWithHistory(groupId, pagination = {}) {
    let result
    try {
      result = await request({
        environment,
        type: 'query',
        name: 'getAccreditationRequestsWithHistory',
        variables: { groupId, pagination },
        way: query_way,
        has_catch: true
      })
    } catch (_) {
      result = await this.getAccreditationRequests(groupId, pagination, false)
    }
    if (result === undefined) {
      result = await this.getAccreditationRequests(groupId, pagination, false)
    }
    return result
  }

  // DEPRECATED: use getAccreditationGroupWithHistoryById instead
  async getAccreditationRequests(groupId, pagination = {}) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getAccreditationRequests',
      variables: { groupId, pagination },
      way: query_way,
      has_catch: true
    })
  }

  async createAccreditationGroup(data) {
    return await request({
      environment,
      type: 'mutation',
      name: 'createAccreditationGroup',
      variables: { request: data },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }
  async createAccreditationGroups(data) {
    return await request({
      environment,
      type: 'mutation',
      name: 'createAccreditationGroups',
      variables: { request: data },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }
  async updateAccreditationGroup(id, data) {
    data = removeTypename(data)

    return await request({
      environment,
      type: 'mutation',
      name: 'updateAccreditationGroup',
      variables: { id, request: data },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }
  async archiveAccreditationGroup(id) {
    return await request({
      environment,
      type: 'mutation',
      name: 'archiveAccreditationGroup',
      variables: { id },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }
  async publishAccreditationGroup(id) {
    return await request({
      environment,
      type: 'mutation',
      name: 'publishAccreditationGroup',
      variables: { id },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }

  async updateAccreditationGroupTitle(id, title) {
    return await request({
      environment,
      type: 'mutation',
      name: 'updateAccreditationGroupTitle',
      variables: { id, title },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }

  async updateAccreditationRequest(accreditationGroupId, requestId, model) {
    return await request({
      environment,
      type: 'mutation',
      name: 'updateAccreditationRequest',
      variables: { accreditationGroupId, requestId, model },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }
}